import React from 'react';
import { OverlayTrigger, Popover } from "react-bootstrap";
import authSlice from "../../store/auth/authSlice";
import { useDispatch } from 'react-redux';
import Avatar from '../commonComponents/Avatar';

function TableMember(props) {
    const dispatch = useDispatch();
    const openProfile = (userid, offeringuserid) => {
        dispatch(
            authSlice.actions.setProfileData({
                userId: userid,
                offeringUserId: offeringuserid,
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userid,
                offeringUserId: offeringuserid,
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };

    const popover = (
        <Popover id="popover-basic" className="profilePopover">
            <div className="popover-profile-top-section">
                {/* <div className="profile-picture">
              <div className="profile-avatar">
              <UserThumbnail currentUser={true} className="profile-avatar" />
              </div>
            </div> */}
                <Avatar {...props} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {props.firstName + " " + props.lastName}
                    </div>
                    <div className="profile-teamname">{props.teamName}</div>
                    <div className="profile-missionname">{props.missionName}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{props.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(props.id, props.offeringUserId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );
    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
        >
            <span className="team-members-name">{props.firstName + " " + props.lastName}</span>
        </OverlayTrigger>
    );
}

export default TableMember;